import { Injectable } from '@angular/core';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Platform } from '@ionic/angular';

import { Env } from './env';
import { envSettings } from './env-settings';
import { PlatformName } from './env-platform';


/**
 * la classe che si occupa di fornire le informazioni sul runtime environment
 */
@Injectable( { providedIn: 'root' })
export class EnvResolver {

    constructor(public platform: Platform
        // , private readonly deploy: Deploy
        , private appVersion: AppVersion) {
    }

    public init(): Promise<Env> {
        console.log('platforms ' + JSON.stringify(this.platform.platforms()));
        if (this.platform.is(PlatformName)) { // ex cordova
            console.log('resolving cordova environment');
            return this.resolveCordova(this.appVersion);
        } else {
            console.log('resolving browser environment');
            return this.resolveBrowser(this.platform);
        }
    }

    private resolveCordova(appVersion: AppVersion): Promise<Env> {

        return new Promise(function(resolve, reject) {
            const namePromise = appVersion.getPackageName();
            // ios: CFBundleVersion (codice con anche numero di build)
            // android: versionCode (codice che deve essere progressivo)
            // let codePromise = appVersion.getVersionCode();
            // ios: CFBundleShortVersionString (codice di 3 cifre che compare nello store)
            // android: versionName (nome descrittivo)
            const codePromise = appVersion.getVersionNumber();


            // deploy.info().then(info=>{
            //    console.log('deploy info',info);
            // });

            // deploy.getMetadata().then(met=>{
            //    console.log('deploy met',met);
            // });

            Promise.all([namePromise, codePromise]).then(values => {

                //  * decode del tenant da package name, sostituito perchè da file è più flessibile (e sicuro)
                // let tenant = values[0].substr(values[0].lastIndexOf('.')+1);
                // if(!tenant || tenant == 'docenti')
                //     reject('impossibile ricavare il tenant dal package name: '+name);


                //  * decode dal tenant da file di settings specifico
                const tenant = envSettings.tenant;
                if (!tenant) {
                    reject('impossibile ricavare il tenant dal pacchetto cordova. Verificare il file env-settings');
                }

                const version = values[1]; // +'.'+values[2];

                resolve(Env.forApp(tenant, version));
            });
        });
    }

    private resolveBrowser(platform: Platform): Promise<Env> {
        // i default
        // let tenant = 'abafi';
        let tenant = 'unikore';

        // let env = 'local'; // punta al bff LOCALE con pwa locale
        // let env = 'loclocprod'; // punta al bff LOCALE con pwa locale
        let env = 'locdev'; // punta al bff DEV in paas con pwa locale
        // let env = 'loctest'; // punta al bff DEV in paas con pwa locale
        // let env = 'loctest2'; // punta al bff DEV in paas con pwa locale

        let extbaseurl: string;

        return new Promise(function(resolve, reject) {
            try {
                    // ricava tenant ed env parsando l'url
                    console.log( 'platform.url ' + platform.url());
                    let match: string[] = /(\w+)(-(\w+))?.appmobile.cineca.it/.exec(platform.url());

                    if (!match || match.length !== 4) {
                        match = /(\w+)-pwa(.(\w+))?.app.cineca.it/.exec(platform.url());
                        if (match && match[3] && match[3] === 'pp') {
                            match[3] = 'test';
                        }
                    }

                    if (!match || match.length !== 4) {
                        // piccolo imbroglietto per utilizzare due ionic serve contemporanei
                        // su porte diverse (ionic serve -p 8101)
                        if ( platform.url().match('8101')) {
                            console.log( 'porta 8101');
                            env = 'dev3';
                        }
                        console.log('Impossibile ricavare le informazioni di env.. useremo i default ' );
                    } else {
                        env = match[3] || 'prod';
                        tenant = match[1];
                    }
                    if (envSettings.hasOwnProperty('extBaseUrl')) {
                        const baseUrlContainer = envSettings['extBaseUrl'].find(baseurl => baseurl.env === env);
                        if (baseUrlContainer) {
                            console.log('baseUrlContainer', baseUrlContainer);
                            extbaseurl = baseUrlContainer.url;
                        }
                    }
            } catch (error) {
                console.log('Errore nel ricavare le informazioni di env dovrebbe accadere solo nei test', error);
            }

            resolve(Env.forPWA(tenant, env, '', extbaseurl));
        });
    }
}
